
import enLocale from 'element-ui/lib/locale/lang/en'

export default {

  ...enLocale,
  route: {
    pending: 'Pending',
    photo: 'Drag Photo',
    login: 'Login',
    mobileLogin: 'Mobile Login',
    project: 'Project',
    detail: 'Deep Displacement Detail',
    projInfo: 'Project Info',
    dtuTask: 'DTU Task',
    dataDetail: 'Data Detail',
    monitorPoint: 'Monitor Point',
    curveChart: 'Curve Chart',
    monitorType: 'Monitor Type',
    task: 'Task',
    caiji: 'Collection Task',
    dtuTaskMenu: 'DTU Task',
    warning: 'Alert Push',
    bigScreen: 'Big Screen',
    vipLogin: 'VIP Login',
    vipHome: 'VIP Home',
    projectMenu: 'Project',
    audit: 'Audit',
    device: 'Device',
    certificateDownload: 'Certificate Download',
    documents: 'Documents',
    versionInfo: 'Version Info',
    user: 'User',
    report: 'Report',
    getData: 'Get Data',
    overview: 'Async Message Middleware',
    exceptions: 'Exceptions',
    buildingProj: 'Under Monitoring',
    completedProj: 'Completed',
    projectManagement: 'Project Management',
    uncompletedAudit: 'Unaudited',
    completedAudit: 'Audited',
    downloadData: 'Download Data',
    attentation: 'Notes',
    newReport: 'Report',
    decidechongzhi: 'Device Recharge',
  },
  typelist: {
    water: 'Water Level',
    datawater: 'Digital water level meter',
    shuxiang: 'Vertical Displacement',
    yeya: 'Hydraulic Level',
    yeya1: 'Hydraulic Level 2',
    yeye3: 'Hydraulic Level 3',
    yacha: 'Pressure Differential Static Level EA-HHL',
    cidian: 'PTH203 Magnetostrictive Static Level',
    yeyaM: 'Hydraulic Level EA-LP3(M)',
    shen: 'Deep Horizontal Displacement',
    shened4ro: 'Deep Horizontal Displacement EA-DHL4Pro',
    shende4: 'Deep Horizontal Displacement EA-DHL4',
    shende4s: 'Deep Horizontal Displacement EA-DHL4(CS)',
    shende3: 'Deep Horizontal Displacement EA-DHL3',
    shende2: 'Deep Horizontal Displacement EA-DHL2',
    shende1: 'Deep Horizontal Displacement EA-DHL1',
    qingxie: 'Tilt',
    qingjiao: 'Tilt Merter',
    dianjie: 'Electrolytic Tilt Meter',

    liefeng: 'Crack',
    liefenbjianc: 'Crack Monitoring',
    tuliao: 'Coating Crack',

    weiyi: 'Displacement',
    laxian: 'Tension-type Displacement Meter',
    laxian2: 'Tension-type Displacement Meter EA-HLD2',
    jiguange: 'EA-LRF2 Laser Rangefinder',
    haomi: 'Millimeter-Wave Radar',
    jice: 'Laser Rangefinder',
    lsji: 'L2s Laser Rangefinder',
    a100jiguang: 'A100/SK100 Laser Rangefinder',
    dianzu: 'Resistance Displacement Meter',

    moni: 'Analog Quantity',

    power: 'Force',
    luogan: 'Screw Axial Force Meter',
    dianzu: 'Resistance Force Meter',

    raodu: 'Deflection (Vertical Displacement)',
    zhenlie: 'Array Displacement Meter',
    zhenliee4: 'Array Displacement Meter EA-DHL4Pro',

    shoulian: 'Convergence Deformation',
    yingli: 'Stress and Strain',
    dianzu: 'Resistance Strain Gauge',
    zhenxuan2: 'Vibrating Wire Strain Gauge EA-VSR2',
    zhenxuan3: 'Vibrating Wire Strain Gauge EA-VSR3',
    zhenxuankai: 'Vibrating Wire Strain Gauge (CS)',
    zhenxuanying: 'Vibrating Wire Strain Gauge YS-VW1004',

    gang: 'Steel Support Axial Force',
    easitong: 'EA-VSR3 Four-channel 485 Vibrating Wire Reader',
    ea2sitong: 'EA-VSR2 Four-channel 485 Vibrating Wire Reader',
    zhenkai: '485 Vibrating String Read Meter (CS）',
    ysvw: 'YS-VW1004 Four-channel Vibrating Wire Data Collector',

    hunni: 'Concrete Support Axial Force',
    maogan: 'Internal Force of Anchors and Soil Nails',
    kunxi: 'Pore Water/Soil Pressure',

    wenshidu: 'Temperature and Humidity',
    bweduji: 'TH10S-B Temperature and Humidity Meter',
    ifdc: 'IFDC21-PT100',
    rs: 'RS15-C',

    fengsu: 'Wind Speed and Direction',
    sncf: 'SN-CFSFX-N01',

    guangxue: 'Optical Rainfall',
    sngy: 'SN-GYL-N01',
    zhendong: 'Vibration and Tilt',

    turang: 'Soil Temperature and Moisture',
    turangwendu: 'Soil Temperature and Moisture Transmitter RS-WS-N01-TR-1',

    zhendong2: 'Vibration Monitor 2',
    boan: 'Revetment',
    shijue: 'Visual Displacement',
    acn: 'ACW-GNSS800',
    gnss: 'GNSS／RTK',

  },
  heaher: {
    picshangshuan: 'pic upload',
    shijueweiyi: 'visual Move',
    boan: 'Revetment',
    zhendongjiance2: 'Vibration Monitor 2',
    zhendongjiance: 'Vibration and Tilt',
    jiancedian: 'monitoring point',
    dturenwu: 'DTU Task',
    caijiduan: 'Collection end settings',
    DTUOn: 'DTU bind/unbind'


  },
  wulianwang: {
    proname: 'Project Name',
    chaxun: 'Query',
    resetchonbgz: 'Reset',
    index: '#',
    shebeiID: 'Device ID',
    shebeitype: 'Device Type',
    iccid: 'ICCID',
    wulianwangdata: 'IoT expiration date',
    shengchengorder: 'Generate order',
    orderlist: 'Order List',
    qingselect: 'Please select the input IoT device',
    qingdecideid: 'Please select the input Device ID',
    qingiccid: 'Please select the input ICCID',
    shengvalue: 'Generate order recharge',
    qingxufei: 'Please enter the renewal duration',
    xufeikong: 'The renewal duration cannot be empty',
    shunum: 'Please enter a positive integer greater than 0',
    qingproname: 'Please enter the project name',
    xufei: 'Renewal duration',
    yue: 'month',
    total: 'In total',
    xiang: 'items',
    yixuanze: 'Selected',
    shenhe: 'Audit',
    chongzhi: 'Recharge',
    dingdanbianhao: 'Order Number',
    chongzhishi: 'Top-up duration',
    shebeinum: 'Number of devices',
    orderstatus: 'Order Status',
    chuangjiandata: 'Creation Date',
    caozuo: 'Operation',
    back: 'Back to previous page',
    chongzhidata: 'Maturity date after recharge',
    chongdata: 'Expiration Date',
    orderxiang: 'Order Details'



  },
  login: {
    title: 'User Login',
    username: 'Username',
    password: 'Password',
    captcha: 'Captcha',
    submit: 'Login',
    Noaccount: 'No account',
    forgetpass: 'Forgot password',
    mobile: 'Mobile',
    conpanyname: 'company name',
    passconfirm: 'Confirm Password',
    Confirm: 'Confirm',
    phoneline: 'Mobile login link',
    registerphone: 'Please enter registered phone number',
    registerphonesuccess: 'Registration successful, the staff will conduct a review and notify you once the review is successful. Please be patient and wait',
    finesecird: 'Retrieve Password',
    phone: 'phone  number',
    register: 'register',
    getcaptcha: "get captcha",
    selectLanguage: 'Select Language',
    usernamePlaceholder: 'Please enter username',
    passwordPlaceholder: 'Please enter password',
    captchaPlaceholder: 'Please enter captcha',
    companyPlaceholder: 'Please enter company name',
    phonePlaceholder: 'Please enter phone number',
    phoneMissing: 'The phone number is incorrect, please fill it in again',
    reenterpassword: 'Please reenter your password',
    passmissing: 'Passwords do not match',
    usernameRequired: 'Username is required',
    passwordRequired: 'Password is required',
    captchaRequired: 'Captcha is required',
    captchaError: 'Captcha is incorrect',
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed'
  },
  user: {
    title: 'Personnel Management',
    title1: 'User Information',
    rowindex: '',
    usertype: 'User Type',
    username: 'Username',
    shenhequanxian: 'Review permissions',
    xiangmuquanxian: 'Project management authority',
    phonenumber: 'mobile phone number',
    mima: 'password',
    quemima: 'Confirm Password',
    Confirm: 'Confirm',
    caozuo: 'Operation',
    bangdingweixin: 'Bind WeChat',
    startpass: "Enter original password",
    newpass: "Confirm new password",
    innewpass: 'Enter new password',
    xiugaimima: 'Change password',
    empty: 'Cannot be empty',
    newoldas: 'New and old passwords cannot be the same',
    phonePlaceholder: 'Please enter phone number',
    phoneMissing: 'The phone number is incorrect, please fill it in again',
    passmissing: 'Passwords do not match',
    bianji: 'edit',
    picupdata: "Image upload",
    clickpic: 'Click to upload logo image',
    logosize: 'Logo image size requirement: 208 * 66px',
    beisize: 'The size requirement for the top background image is 896 * 66px',
    clicbeipic: 'Click to upload background image',
    logiopreview: 'Logo image preview',
    beijingpreview: "Preview of Top Background Image",
    weixinbind: 'WeChat Binding',
    weixinunbind: 'Unbind WeChat',
    clickcalcelbind: 'Click to unbind',
    clickcalcelunbind: 'Click to bind WeChat',
    comfirmbind: 'Bound',
    cjsucess: 'Created successfully',
    cjfail: 'Creation failed',
    delelogin: 'Do you want to delete the logo',
    delebeijing: 'Do you want to delete the top background image',
    sfbind: 'Do you want to unbind',
    bindsu: 'Unbound successfully',
    calceljie: 'Unbind canceled',
    sava: 'save',
    delete: 'delete',
    adduser: 'New user',
    bianjianuser: 'Modify information',
    deletedata: 'This operation will delete the user. Do you want to continue?'
  },
  pending: {
    indexrows: '#',
    type: 'Type',
    name: 'Name',
    time: 'Time',
    caozuo: 'Operation',
    rightdeal: 'Process immediately',
    selectItem: 'Please select the items that need to be deleted',
    deletedata: 'Confirm deletion?'
  },
  buildingProj: {
    indexrows: '#',
    status: 'Status',
    projectname: 'Project Name',
    startstime: 'Start time',
    endtime: 'End time',
    caozuo: 'Operation',
    changedeal: 'Switch to this project'

  },
  DevData: {
    shebeiname: 'Device Name',
    wenjianDownload: 'File Download',
    Download: 'Download'
  },
  dtuTaskMenu: {
    indexrows: '#',
    rows: 'Serial number',
    dingtime: 'Timing',
    everyday: 'Every day',
    everyinge: 'Once every other day',
    duankoutype: 'Port type',
    status: 'Status',
    starttime: 'Start time',
    jiangetime: 'Interval',
    monitorType: 'Monitoring point type',
    monitorbianhao: 'Monitoring Point Number',
    monitorId: 'Monitoring Point ID',
    caozuo: 'Operation',
    taskinfo: 'Task information',
    taskstatus: 'Task status',
    jiangemin: 'Interval (minutes)',
    celiangshuliang: 'Number of measurement units',
    celiangfangxiang: 'Measurement unit direction',
    monitorTypeobj: 'monitoring target',
    computed: 'computational direction',
    openlvbo: 'Enable filtering',
    moniname: 'Analog quantity name',
    dtuid: 'DTU device ID',
    longyouhua: 'Long term offset optimization',
    chuanganqi: 'Sensor depth (elevation)',
    adress: 'Address',
    basePoint: 'Datum point',
    linexian: 'Line reference point',
    cankaodian: 'Reference point',
    chuantype: 'Sensor type',
    fenbianlv: 'Resolution',
    caiyangcisu: 'Sampling times',
    liangcheng: 'Range',
    celiangfangshi: 'Measurement method',
    computedgongshi: 'Calculation formula',
    danwei: 'Unit',
    jizhunposition: 'Reference position',
    injechuan: 'Connect temperature sensor',
    excmple: "Example: Depth of 10.0 meters should input -10.0",
    beizhu: 'Remark',
    expleone: 'The proximal end refers to the measurement location at 0m, while the distal end refers to the farthest measurement point',
    expletwo: 'Please refer to the instructions for using the omnidirectional displacement meter for the specific installation form and corresponding setting parameters',
    remarkone: 'When setting the reference point, that is, the reference point of the measuring line is the moving reference point, used to transmit vertical displacement across the measuring line. The calculation method is: the vertical displacement value of this measuring point=the liquid level height of this measuring unit - the liquid level height of the measuring line reference point+the displacement value of the reference point',
    remarktwo: ' In order to ensure the real-time transmission of measurement data, the collection time set for all measurement points within this measurement line should be at least 2 minutes later than the reference point collection time.',
    cheap: 'Any sensor has the physical characteristic of zero drift and cannot be avoided. Sliding inclinometers can cancel each other out through forward and backward measurements, while fixed inclinometers cannot achieve forward and backward measurements.',
    cheap1: 'In order to eliminate zero drift, the platform will automatically treat slopes below the zero drift elimination threshold as unchanged, making the data appear abnormally stable.',
    cheap2: 'The algorithm for zero drift elimination was first proposed by us and is currently not available in the industry. Therefore, when encountering our product for the first time, you may feel that the data is abnormal',
    cheap3: 'This algorithm only eliminates slow drift and does not reduce the rapid deformation caused by excavation, so it does not affect the monitoring of excavation',
    cheap4: 'Please feel free to use it.',
    cixia: "Click here to download",
    jizhou: 'Monitoring axis',
    tongdao: 'Channel Selection',
    addrenwu: 'Add new task',
    bianjirenwu: 'Editing task',
    guanliadd: 'If you need to encrypt the collection frequency, please contact the backend administrator',
    mintime: 'The minimum interval time setting limit is 30',
    timeempty: 'The start time cannot be empty',
    chuantypemes: 'Please select sensor type',
    minitypeempty: 'Monitoring point type cannot be empty',
    canempty: 'The reference point cannot be empty',
    canself: 'The reference point cannot be for oneself',
    cebasaline: 'The benchmark point of the survey line cannot be empty',
    rowzheng: 'The serial number must be a positive integer',
    addressempty: 'The address cannot be empty',
    numinput: 'Please enter a value between 0 and 255',
    deepempty: "Sensor depth (elevation) cannot be empty",
    xuanchuantype: 'Please select sensor type',
    zidingzheng: 'Custom input content can only be integers',
    zishuempty: 'Custom input content cannot be empty',
    moniempty: 'The analog quantity name cannot be empty',
    biceempty: 'Monitoring point number cannot be empty',
    dtuId: 'DTU device ID cannot be empty',
    compuempty: 'The calculation formula cannot be empty',
    danweiempty: 'Unit cannot be empty',
    jianzhouempty: 'The monitoring axis cannot be empty',
    bianhaoempty: 'Number cannot be empty',
     wuxian:'wireless',
    xuanzetime:'Select date and time',
    qingshurudizhi:'Please enter the address',
    qingshuruxuhao:'Please enter the serial number',
    qingshutujisuangongsi:'Please enter the calculation formula',
    qingshurudanweimijngch:'Enter the name of the organization',
    qingshuruDTu:'Please enter the DTU device ID',
    qingshurdanyuanshul:'Please enter the unit quantity',
    qingshurceliangdanyuanshul:'Please enter the number of measurement units',
    qingshurucelgongshi:'Please enter the measurement formula-',
    qingshurufenbianlv:'Please enter the resolution',
    qingshuruliangcheng:'Please enter the range',
    qingxuanzecelianghduixiang:'Please select the monitoring object',
    congjinyuan:'Observing from the proximal end to the distal end',
    qingshurcefang:'Please enter the direction of the measuring unit',
    qingcaijicish:'Please enter the number of sampling times',
    pleasejisuanfangxinag:'Please enter the calculation direction',
    qingxuanzecankaodian:'Please select a reference point',
    qingxuanzecexianjizhuandian:'Please select the reference point for the survey line',
    jizhuandian:'Please select a reference point',
    ceju:'Range interpolation is 0.5m ',
    jiancezhoufangxia:'Please select the direction of the monitoring axis',
    jiancebianhao:'Please enter the monitoring point number',
    shuru:'Please select',
    qingnum:'Please enter a numerical value',
    qingchuangao:'Please enter sensor depth (elevation)',
    jiken:'foundation pit',
    matou:'dock',
    bianma:'Edge code',
    danciceliang:'Single quantity',
    zidonglianxucel:'Automatic continuous measurement',
    qiangwending:'Strong stability',
    wending:'stable',
    guanbi:'Close',
    zidingyi:'Customization',
    pianlm:'Slightly sensitive',
    humianchaokengnei:'Curved surface facing into the pit',
    humianchaokengwai:'Curved surface facing outside the pit',
    podi:'Curved surface towards the bottom of the slope',
    potop:'Curved surface facing the top of the slope',
    huhai:'Curved surface facing the sea (river) side',
    hance:'The arc faces the shore side',
    huazuo:'Forward to the sea (river) side, with the cable outlet of the pulley block facing left',
    huayou:'Forward to the sea (river) side, with the cable outlet of the pulley block facing right',
    hushang:'Curved surface facing upwards',
    huxia:'Curved face downwards',
    huleft:'Curved surface to the left',
    huright:'Curved surface to the right',
    boxia:'from top to bottom',
    xiabo:'from bottom to top',
    jinduan:'proximal',
    yuanduan:'remote end',
     beforeleft:'Forward facing into the pit, with the pulley cable outlet facing left',
    beforeright:'Forward facing into the pit, with the pulley cable outlet facing right',
    poleftzuo:'Forward facing towards the bottom of the slope, with the cable outlet of the pulley system facing left',
    polrightyou:'Forward facing towards the bottom of the slope, with the cable outlet of the pulley system facing right',
    outlinetop:'The direction of the outgoing line is upward',
    outlinebot:'The outgoing direction is facing downwards',
    outlineleft:'The direction of the outgoing line is towards the left',
    outlineright:'The direction of the outgoing line is towards the right',
    DTutype:'DTU type',
     yuanchengmima:'Remote Password'




  },
  caiji: {
    indexrows: '#',
    renwuname: 'Task name',
    status: 'Status',
    time: 'Time',
    caozuo: 'Operation',
    caozuodetail: 'Operation details',
  },
  // 未审核
  uncompletedAudit: {
    indexrows: '#',
    projectname: 'ProjectName',
    updatetime: 'Submission time',
    shenhetime: 'Review time',
    ananyyuan: 'Analyst',
    shenheyuan: 'Reviewer',
    shenresult: 'Audit results',
    weishenhe: 'Unreviewed',
    analytime: 'Analysis time',
    enjeerinfo: 'Basic Engineering Information',
    enjeername: 'Project Name',
    enjeerbianhao: 'Project Number',
    enjeeradress: 'Construction site',
    buildingwei: 'Contractor',
    ananyyuaninfo: 'Analyst Information',
    reason: 'Reason',
    checkbiao: 'View report',
    readbob: 'Confirm the need to withdraw',
    bosucessd: 'Withdrawal successful',
    quxiaosucessd: 'Cancelled withdrawal',
    caozuo: 'Operation',
    read: 'Check',
    bohui: 'Reject'
  },
  // 未审核
  completedAudit: {
    indexrows: '#',
    projectname: 'ProjectName',
    updatetime: 'Submission time',
    shenhetime: 'Review time',
    ananyyuan: 'Analyst',
    shenheyuan: 'Reviewer',
    shenresult: 'Audit results',
    analytime: 'Analysis time',
    enjeerinfo: 'Basic Engineering Information',
    enjeername: 'Project Name',
    enjeerbianhao: 'Project Number',
    enjeeradress: 'Construction site',
    buildingwei: 'Contractor',
    ananyyuaninfo: 'Analyst Information',
    reason: 'Reason',
    checkbiao: 'View report',
    readbob: 'Confirm the need to withdraw',
    bosucessd: 'Withdrawal successful',
    quxiaosucessd: 'Cancelled withdrawal',
    caozuo: 'Operation',
    read: 'Check',
    bohui: 'Reject'
  },
  // 项目管理
  ProjectManagement: {
    ProjectManagement: "ProjectManagement",
    indexrows: '#',
    projectname: 'ProjectName',
    starttime: 'Startime',
    anayquan: 'Analysis permissions',
    shenhe: 'Review',
    shenquan: 'Review permissions',
    status: 'Status',
    caozuo: 'Operation',
    set: 'Setting',
    projecinfo: 'Project Information',
    selectdata: 'Project Date',
    needrow: 'Need to review the process',
    ananyyuan: 'Analyst',
    shenheyuan: 'Reviewer',
    endproject: 'Terminate the project'
  },

  Alertpush: {
    Chadecide: 'conventional equipment',
    Zhudecide: 'Specialized equipment',
    Numberwaring: 'Data Alert',
    Dtucharyichang: 'DTU charging abnormality',
    Dtuclose: 'DTU does not start up properly',
    Dtuellow: 'DTU battery low',
    indexrows: '#',
    jiancetype: 'Monitoring point type',
    danliange: "Single change quantity",
    calliang: 'Cumulative change amount',
    caozuo: 'Operation',
    tuiding: 'Push unsubscribe',
    test: 'Push testing',
    orderread: "WeChat Subscription",
    inputbianhua: 'Please enter the rate of change',
    inputleiji: 'Please enter the cumulative change amount',
    pushsuceess: 'The push unsubscribe function has been completed！',
    setsuccess: 'Setup successful',
    waringtime: 'Warning push time',
    orderdelete: 'Do you want to delete this alert value',
    pushread: 'The push test information has been sent, please check on WeChat',
    pushtimed: 'Please set the alert information push time first！',
    yujingset: 'Warning information setting completed',
    yujingweiset: 'Warning line setting not completed',
    onceset: 'The threshold for a single change cannot be empty',
    twoset: 'The threshold for cumulative change cannot be empty'
  },
  // 设备管理
  Equipment: {
    decide: 'Equipment Management',
    indewrows: '#',
    type: "Type",
    ProjectName: 'ProjectName',
    DeviceID: 'Device ID',
    HardwareVersionNumber: 'Hardware version number',
    SoftwareVersionNumber: 'Software version number',
    State: 'Device Status',
    usering: 'In use',
    all: 'All',
    passload: "Certificate of Conformity Download",
    duringtime: "Time period",
    decidetype: "Device Type",
    Num: 'Quantity',
    boring: 'Generate',
    rechong: 'Reset',
    message: 'Please select device type'

  },

  ChildPrj: {
    ministatus: 'Monitoring point status',
    minitotal: 'Total number of monitoring',
    yichang: 'Total number of abnormal monitoring points',
    projectinfo: 'Project Information',
    projectname: "Project Name",
    shenhe: 'Review process',
    shenheyuan: 'Reviewer',
    starttime: 'Start time',
    analy: 'Analyst',
    list: 'List of DTU2 and DTU3',
    indexrows: '#',
    type: 'Type',
    decideid: 'Device ID',
    currenstatus: 'Current status',
    yichanginfo: 'Exception message',
    charge: 'Charging voltage',
    ele: 'Power level%',
    openleave: 'Shutdown/Offline Time',
    planling: 'Plan the next startup time',
    messqiang: 'Signal strength',
    yingban: 'Hardware version',
    guti: 'Solid version',
    shenji: 'Upgrade',
    modelstatus: 'Energy saving mode status',
    open: 'Open',
    close: 'Close',
    caozuo: 'Operation',
    history: 'Historical Status',
    renwu: 'Task',
    moset: 'Energy saving mode setting',
    guread: 'Solid version description',
    newsguti: 'Latest Solid Version',
    elemodel: 'Power Saving Mode',
    starttime: 'Start time',
    jiangeshijian: 'Time interval',
    endtime: 'End time',
    baninfo: 'Version Information',
    gushen: 'Firmware update',
    Dtuset: 'DTU binding settings',
    decideset: 'Device Status',
    bindproject: 'DTU has been bound to the project',
    zhongduan: 'Terminal information',
    surplusElectricity: "Available duration",
    shutdowntime: 'Shutdown time',
    nextstarttime: 'Next startup time',
    onduty: 'Duty hours',
    kcode: 'Remote connection',
    quguxiao: "Are you sure to perform firmware upgrade",
    caoqu: 'Operation canceled',
    openjie: 'Activate energy-saving mode, DTU intermittently online, confirm execution？',
    openjie1: 'Turn off energy-saving mode, DTU is always online, confirm execution?',
    setbing: 'The device has been bound',
    setbing1: 'The device has been unbound',
    qujiechu: 'Are you sure to unbind',
    resuceess: 'Rebind successful',
    checkrtk: "Viewing GNSS/RTK Settings:",
    bindset: "DTU binding settings",
    DTUrest: 'DTU sleep mode',
    dtudecideID: 'DTU device ID',
    Dtuonline: 'DTU Online',
    lasttime: 'Last online time',
    candtu: 'The parameters set by DTU will be recorded and automatically set when DTU is next online',
    enginfo:'Engineering Information',
    day:'day',
    hour:'hour',
    fen:'minute',
    jianonlie:'DTU intermittent online',
    shizhong:'DTU is always online'





  },
  // 监测点位置图和监测点列表
  MonitorPoint: {
    position: 'Location map of monitoring points',
    Minilist: 'Location map and list of monitoring points',
    caiji: 'Can be collected',
    all: 'All',
    pic: 'Image list',
    shebeitype: 'Device Type',
    caijizhuangtai: 'Collection Status',
    chuanganstatus: 'Sensor status',
    decideid: 'Device ID',
    testid: 'Measuring point number',
    lastdata: 'The last data',
    testtime: 'measure time',
    rest: "Remaining battery",
    checkdata: 'View data',
    indexrow: '#',
    status: 'State',
    testbian: "Measuring point number",
    testname: 'Measuring Point Name',
    zuihoudata: 'Final measurement data',
    type: 'Type',
    shebeiid: 'Device ID',
    unit: 'Unit',
    yujing: "Monitoring and early warning",
    lasttime: 'Last measurement time',
    shebeiwen: 'Equipment temperature',
    caozuo: 'Operation',
    testset: 'Measurement point name setting',
    renwu: 'Task',
    testdata: 'Test data',
    zhongduaninfo: 'Terminal information',
    pushzhuandecide: 'Add specialized equipment',
    testtype: 'Monitoring point type',
    testbianhao: 'Monitoring point number',
    shebeiname: 'Device name',
    jianceid: 'Monitoring device ID',
    shebeiSn: 'Device SN',
    babiaoID: 'Target ID',
    daoru: 'Import',
    minidelece: 'Do you want to continue deleting this monitoring point',
    inputtype: 'Please enter the monitoring point number',
    inputdecide: 'Please enter the device ID of the monitoring point',
    inputtarget: 'Please enter the target ID',
    inputjiance: 'Please enter the monitoring point type',
    jiancelist: 'The monitoring list',
    shebeiid1: 'Please enter the device name',
    shebeidid1: 'Please enter the device ID',
    shebeidid2: 'Please enter the device SN',
    daorutype: 'Import type',
    viewpic:'View the image',
    shushitup:'Initial image',
    celpic:'Measure the image'
  },
  // 历史数据页面
  MonitorPointProject: {
    revalue: 'Recharge',
    zhongduan: 'Terminal information',
    task: "Task",
    caozuo: 'Operation',
    checkxiangqing: 'View details',
    Download: "Download",
    checkxun: 'Query',
    cedianbianhao: 'Measurement point number',
    cedianmingcheng: 'Measuring Point Name',
    decideid: 'Device ID',
    currentstatus: 'Current status',
    yichanginfo: 'Exception message',
    ele: 'Power level',
    xinhaoqiangdu: 'Signal strength',
    lasttime: 'Last online time',
    delete: 'Delete',
    checklocation: 'View location',
    getlocation: "Get the latest positioning",
    shiyutu: 'Time domain plot',
    pinyutu: 'Frequency domain plot',
    quxiantu: 'Curve graph',
    datacai: 'Data collection',
    insettask: 'Scheduled task',
    canset: 'Parameter Settings',
    yuzhiset: 'Threshold setting',
    datachange: 'Data switching',
    wetxingmap: "Satellite map",
    oncedata: 'Single instance data',
    daydata: 'Daily statistical data',
    celist: "Test List",
    tembuchang: 'Temperature compensation',
    shichengset: 'Support Settings',
    datadeal: 'Data Processsing',
    openchange: 'Display switching',
    setdata: 'Set number：',
    zhishu:'Set number',
    yitichu: 'Abnormal unit removal',
    checkzero: 'View zeroing value',
    checkstart: 'View initial values',
    lieji: 'Cumulativa value',
    guanvalue: 'Tube shape value',
    timeduring: 'Time period',
    zhengvalue: 'Positive values move upwards,negative values move downwards',
    updetail: "Detailed data exceeding the storage limit will be cleaned up. Please download it promptly if necessary",
    downlimit: 'Upper limit',
    downq: "Current",
    indexrows: '#',
    testtime: 'Measure time',
    speedfeng: "Peak acceleration (mm/s ²)",
    jiaspeed: 'Acceletation',
    sudufeng: "Peak speed (mm/s)",
    sudu: 'Speed',
    weiyifeng: 'Peak displacement (mm)',
    zhupin: 'Main oscillator frequency (Hz)',
    timefanwei: 'Time range:',
    fengzhicheck: 'Peak search ≥',
    waterlevel: 'Water level',
    yeyawater: 'Hydraulic level',
    yeyawater2: 'Hydraulic level2',
    yeyawater3: 'Hydraulic level3',
    shuci: 'PTH203 magnetostrictive static level',
    shuxiang: 'Vertical displacement',
    sheepwei: 'Deep horizontal displacement',
    sheepwei1: 'Deep horizontal displacement EA-DHL2',
    sheepwei4: 'Deep horizontal displacement EA-DHL4',
    zhicheng: 'Steel support axial force',
    hunnitu: 'Concrete support axial force',
    maogan: 'Internal forces of anchor rods and soil nails',
    kongxishui: 'Pore water/soil pressure',
    gangjiyingli: 'Reinforcement stress',
    qingxie: 'Tilt',
    qingjiao: 'Clinometer',
    jiguangcejuyi: 'Laser rangefinder',
    l2yiguang: 'L2s laser rangefinder',
    askjiguang: 'A100/SK100 laser rangefinder',
    ealjiguang: 'EA-LRF2 laser rangefinder',
    tuliao: 'Paint cracks',
    naodu: 'Deflection (vertical displacement)',
    yingli: 'Stress-strain',
    eleyin: 'Resistance strain gauge',
    zhenxuan: 'Vibrating wire strain gauge',
    weiyi: 'Displacement',
    elewei: 'Resistance displacement sensor',
    laxianshi: 'Wire type displacement sensor',
    laeahld2: 'Wire type displacement sensor EA-HLD2',
    turang: 'Soil temperature and moisture',
    turangtel: 'Soil temperature and moisture transmitter RS-WS-N01-TR-1',
    Gnsswei: "GNSS displacement monitoring",
    GNssrtk: 'GNSS／RTK',
    zhenlie: 'Array displacement meter',
    sheepwei3: "Deep horizontal displacement EA-DHL3",
    sheepwei4p: "Deep horizontal displacement EA-DHL4Pro",
    zhenlieea: 'Array displacement sensor EA-DHL4Pro',
    shoulie: 'Convergent deformation',
    zhenxie: 'Vibration and inclination angle',
    zhenjiao: 'Vibration and Tilt',
    boan: 'Revetment',
    elejiao: 'Electrolyte inclinometer',
    zhenxie2: 'Vibration Monitor 2',
    haomilei: 'Millimeter wave radar',
    yuanshi: 'Original value (mm)',
    leiji: 'Cumulative value (mm)',
    daychage: 'Daily variation',
    ceposition: 'Measurement point location (m)',
    washui: 'Horizontal (m)',
    shuxia: 'Vertical (m)',
    restele: 'Remaining battery capacity (%)',
    giveele: 'Supply voltage (V)',
    bettery: 'Battery voltage (mV)',
    huantel: 'Environmental temperature (℃)',
    yachajing: 'Differential pressure static leveling EA-HHL',
    guiling: 'Reset to zero',
    shestart: 'Set initial value',
    openjigang: 'Turn on the laser',
    deexcel: 'Export',
    rechong: 'Recount',
    rigindata: 'Export of raw data',
    basesheep: 'Reference point elevation',
    inport: 'Import',
    lastten: 'The last ten times',
    historyten: 'Ten times in history',
    all: 'All',
    decidewangluo: 'Measurement network number',
    state: 'State',
    weiyivalue: 'Displacement value',
    wendu: 'Temperature (℃)',
    origindata: "Raw data (mm)",
    tichudata: 'Exclude daytime data',
    timearea: 'Time interval',
    lvbo: 'Filtering',
    wenxiuxi: 'Temperature correction coefficient',
    shoucomputer: 'Manual calculation',
    zidongcomputer: 'Automatic calculation',
    weibaocun: 'Unsaved',
    downset: "Download the setting template",
    upsetfile: 'Upload data file',
    starttime: 'Start time',
    liji: 'Effective immediately',
    lijicomputer: 'Calculate immediately',
    baseheight: 'Reference point elevation value (unit: mm)',
    liefengwidth: "Change in crack width (mm)",
    guilingvalue: 'Reset to zero value',
    onlysava: 'Only save parameters, do not change historical data',
    saveset: 'Save parameters and modify historical data',
    yingbian: 'Strain (μ ε)',
    yingli: 'Stress (MPa)',
    flexmo: 'Elastic modulus E',
    cetestjishu: 'Measurement and counting',
    tongdaodai: 'Channel code',
    passstress: 'Channel',
    conputerfang: 'Computational method',
    lak: 'Pull K',
    laB: 'Pull B',
    yaB: "Pressure B",
    engineer: 'Engineering location',
    fenbianlv: 'Resolution',
    level: 'Grade',
    length: 'Length',
    pingyi: 'Translation',
    jinbo: 'Near zero fluctuation suppression',
    longyin: 'Uplift inhibition',
    bili: 'Proportion',
    chushizhi: 'Initial value',
    dealqian: 'Pre-processing',
    dealhou: 'Processed',
    dataalyi: "Data analysis settings",
    deeptiao: 'Deep adjustment',
    deepfangwei: 'Depth range selection',
    toubushou: 'Head convergence',
    quxianping: 'Smooth curve',
    cejuneicha: 'Range interpolation is',
    fuweiyi: 'Negative displacement suppression',
    hengxiang: 'Lateral',
    shuxiang: 'Vertical',
    firstzhicheng: 'The first support',
    secondzhicheng: 'The second support',
    threezhicheng: 'The third support',
    fourzhicheng: 'The fourth support',
    fovezhicheng: 'The fifth support',
    sixzhicheng: 'The sixth support',
    sevenzhicheng: 'The seventh support',
    eightzhicheng: 'The eighth support',
    ninezhicheng: 'The ninth support',
    tenzhicheng: 'The tenth support',
    xiaochuling: 'Eliminate zero drift',
    danfangxiang: 'Unidirectional inhibition',
    yushecanshu: 'Preset parameter 1',
    yushecanshu1: 'Preset parameter 2',
    cediantype: 'Measurement point type',
    sava: 'Save',
    mi: 'meter',
    lishidata: 'historical data',
    tichu: 'Eliminate',
    shifoutichu: 'Should it be removed?',
    tuchusuccess: 'Removal successful',
    shebeiweizhi: 'Device location',

    shoudongcompu: 'manual calculation',
    save: 'save',
    setweican: 'The equipment adopts the coarse positioning of the telecom operator is base station, with a large positioning error (accuracy within 1km), and the positioning position is for reference only',
    caoadd: 'This operation will add a new zero value and save calibration data. Do you want to continue?',
    cibaocun: 'This operation will add a new zero value (X, Y, Z axis) and save the temperature calibration coefficient and zero drift elimination threshold. Do you want to continue?',
    historydatapic: 'Historical data trend chart:',
    guilingdata: 'Zeroing data',
    guilingname: 'Zero value name',
    guilingbeizhu: 'Zeroing remarks',
    shifouliji: 'Is it effective immediately',
    shengxiaosucess: 'Effective immediately and successfully',
    zhishuan: 'Number deleted successfully',
    clearndata: 'Data cleaning',
    menxian: 'Threshold',
    cishu: 'Frequency',
    xiaochupiao: 'Eliminate zero drift',
    jinlingbodong: 'Near zero fluctuation suppression',
    qingshu1o: 'Please enter a value within the range of 1-100',
    danxiang: 'Unidirectional inhibition',
    fuyibai: 'Please enter integer: -100~100',
    zhichengsetyiend: 'Support settings completed',
    zhichengweiend: 'Support settings not completed!',
    selectfan: 'Range selection',
    mito: 'meter to',
    tiaozheng: 'Adjust',
    xiamoshangyi: 'Moving down is positive, moving up is negative',
    zhengweiyi: 'Positive displacement suppression',
    weifuyizhi: 'Negative displacement suppression',
    cejuneicha: 'Distance interpolation is 0.5m',
    startchart: 'Original graphic display',
    inshifou: 'Whether to proceed',
    qihuan: 'switch',
    quqiehuan: 'Switch canceled',
    cedianposition: 'measuring point location',
    tichubaitian: 'Remove daytime data',
    shitestdata: 'measured data',
    guankouheigh: 'Piping height',
    biaodingxishuB: 'Calibration coefficient B',
    biaodingxishuA: 'Calibration coefficient A',
    waterihie: 'Head height',
    laxianchangdu: 'Cable length',
    Adzhi: 'AD value',
    chuanganbianhao: 'Sensor Number',
    zhoulizhi: 'Axial force value(kN)',
    jiancedianname: 'Monitoring point name',
    shengyadianya: 'Boost voltage',
    weiyibianhualiang: 'Displacement variation',
    yingliyingbianliang: 'Strain variation',
    xinzaobi: 'signal-to-noise ratio',
    startorigh: 'raw data',
    rainliang: 'rainfall',
    sunzhao: 'illumination',
    crayli: 'Wind Scale',
    fengdirection: 'wind direction',
    fengspeed: 'wind speed',
    shidu: 'Humidity',
    gaocheng: 'elevation',
    weidu: 'latitude',
    jingdu: 'longitude',
    startzhi: 'raw value',
    cedianxuhao: 'Measuring Point Number',
    shendu: 'Deep',
    zhoujiaodu: 'Axis angle',
    datastatus: 'data status',
    setfirst: 'Set as initial value',
    dianzuzhi: 'resistance value',
    livalue: 'force value',
    shuiweigaocheng: 'Water level elevation value',
    celianngzhi: 'measured value',
    yusetcanshu1: 'Preset parameter 1',
    yusetcanshu2: 'Preset parameter 2',
    zhankai: 'Expand',
    shouqi: 'Put away',
    shanyiweizheng: 'Moving up is positive, moving down is negative',
    zidongpingyi: 'Auto Pan',
    xiangxishuju: 'Detailed data',
    jiewendu: 'Solve temperature sensor',
    zhdong: 'vibration',
    yansuan:'verification',
    la:'pull',
    ya:'press',
    jisuan:'Calculation',
    lingmindu:'Sensitivity conversion coefficient',
    bilixishu:'Proportional coefficient K',
    jsfs:'calculation method',
    shupiweiy:'horizontal displacement',
    testdian:'Measuring point',
    tuichu:'exit',   
     xuji:'Continue',
    shifoutuchutui:'Do you want to exit data processing?',
     kongzhiqiID:'Controller ID' ,
    yiglidangen:'Stress gauge, cross-sectional area of a single steel bar',
    gangjimianji:'Steel bar cross-sectional area',
    gangzong:'Total cross-sectional area of steel bars',
    gagntan:'Elastic modulus of steel bars Es',
    suanmian:'Total cross-sectional area of concrete',
    buganmian:'Total cross-sectional area excluding steel barsv',
    gnggoquan:'Elastic modulus of concrete Ec',
    guilingpianyiliang:'Zeroing offset',
     celie:'List of measurement points',
    weixingshu:'Satellite count',
      shangchuanpic:'Click on the image to upload',
   tulist:'Image list',
   daxiao:'Size',
   yanse:'Color',
   picjihe:'Icon Collection',
  jicedianpeizhi:'Monitoring point location configuration',
   zhengzhifuzhi:'Positive values move upwards, negative values move downwards',
   zhushi:'Commentary: X (East+, West -); Y (North+, South -); Z (up+, down -)',
   shizhudong:'Annotation: X+facing right, X - facing left; Y+up Y - down',
  zhengyiban:'Negative values move towards the outside of the pit',
   fuyiban:'Moving towards the pit',   
   zhengchao:'Negative values move out of the river channel',
   fuchaomove:'Moving towards the river channel',
    diyutubili:'Scale coefficient of time-domain graph',
    caijishijian:'Collection Time',
    fengvalue:'peak value',
    zhendongdingshi:'Vibration monitoring instrument 2 timed task setting',
    upwenjian:'Upload data files',
     julibianhua:'Distance variation (mm)',
     zcxy:'Moving upwards',
   ccxy:'Negative values move downwards',
     syz:'Horizontal Value',
   sxz:'Vertical value',

      datacaosu:'Data operation successful',
   selecttimes:'Please select the number of times',
   selectclean:'Please choose to clear data',
   menxianweizheng:'The threshold value is positive',
   menemty:'The threshold value cannot be empty',
   shustartvalue:'The initial value entered is a numerical value',
   guipi:'The zero offset is a numerical value',
   guivshu:'Return to zero as a numerical value',
   qing10:'Please enter a positive integer with a length ranging from 1 to 10',
   weieidt:'No modifications were made',
   numemty:'The input number cannot be empty',
   shichange:'Do you want to change the name of the measuring point',
   qingchuemty:'Eliminating zero drift cannot be empty',
   nodata:'No data details available',
   zannodata:'There is currently no location data available',
   selcedian:'Please select the measurement point number!',
   xuanzhou:'Please select axis type!',
   xuanfa:'Please choose a direction!',
   selebi:'Please choose a ratio',
   sellong:'Please select uplift suppression',
   sedanfa:'Please select unidirectional suppression',
   jin0:'Please select near 0 fluctuation suppression',
   retongji:'Resurrected data successfully!',
   selvtime:'Please select the number of filters',
   sellv:'Select filter',
   selength:'Please select length',
   sellevel:'Please select a level',
   xuanyicon:'Please enter the content of bulge suppression',
   jinshu:'Please enter near 0 fluctuation suppression data',
   againdata:'Confirm again whether to change the data',
   shichangdata:'Do you want to change the data?',
   zshutype:'The Z series is limited to input numerical types only!',
   yshutype:'The Y series is limited to input numerical types only!',
   xshutype:'The X series is limited to input numerical types only!',
   startempty:'The initial value cannot be empty and the numerical value is numerical',
   enterstart:'Please enter the correct initial value',
   erzhan:'No data available',
   yichangtichu:'Abnormal unit removal completed',
   yiweicheng:'Abnormal unit setting not completed!',
   shudaup:'Data upload successful',
   pleasettui:'Please set the alert information push time first!',
   addsava:'Fill in and save the threshold!',
   tuitest:'The push test information has been sent, please check on WeChat!',
   shuyizhi:'Please enter the correct offset value',
   qingxuanpian:'Please select offset',
   startshushihh:'Please enter the initial value',
   xuavalue:'Please select the initial value',
   xuancan:'请Please select filtering parameters',
   deepfan:'The minimum depth range value is greater than the maximum value. Please select a new value',
   pleafu:'Please check negative displacement suppression',
   fuyifan:'The negative displacement suppression range is 1-100',
   suzhi:'Payment successful',
   caopin:'The operation is too frequent, please try again later',
   dangwu:'The current IoT network card does not support recharging',
   dnochi:'The current DTU does not support recharging',
   fengonly:'Peak retrieval can only be numerical values',
   zhensu:'The scheduled task for vibration monitor 2 has been successfully set',
   setestwei:'Please select or input the location of the measuring point',
   xuanwabao:'Please enter the alarm value',
   changesu:'Please enter the rate of change',
   shuleibian:'Please enter the cumulative change amount',
   xuanbiant:'Select measurement point number',
   shiwateer:'Please enter the measured water level value',
   qingchuanbian:'Please enter the sensor number',
   qingfo:'Please enter the f0 value',
   qingka:'Please enter the value of tensile force K',
   qingkb:'Please enter the value of tensile force B',
   qingyk:'Please enter the pressure K value',
   qingyb:'Please enter the pressure B value',
   yinggangmian:'Please input the cross-sectional area of a single steel bar in the stress gauge',
   ganmian:'Please enter the total cross-sectional area of the steel reinforcement',
   tane:'Please enter the elastic modulus Es of the steel reinforcement',
   quanmian:'Please enter the total cross-sectional area of the concrete',
   bizheng:'Must be a positive number',
   zhenghah:'Positive numbers between 6 and 10000',
   pweima:'Please use WeChat to scan the code for payment',
   weisao:'WeChat QR code payment',
   shuo3fan:'Please enter a value within the range of 0.01~0.3',
   shuo1fan:'Please enter a numerical value within the range of 0.01 to 1',
   shuo150fan:'Please enter integer: 1~50',
   weiding:'WeChat Scan Code Subscription',
   yujingtui:'Warning push time'

      
    








  },

  // rtk
  rtk: {
    title: 'GNSS/RTK displacement monitoring',
    addrtk: 'Add GNSS/RTK displacement monitoring network',
    rowsindex: '#',
    status: 'Status',
    mininame: "Monitoring Network Name",
    testname: 'Measuring Point Name',
    lasttestname: 'Final measurement data',
    unit: 'Unit',
    lasttesttime: 'Last measurement time',
    caozuo: 'Operation',
    testeit: 'Edit the name of the measuring point',
    peiinfo: 'Configuration information',
    addrtk1: ' Add GNSS/RTK',
    editrtk: "GNSS/RTK displacement monitoring point name modification",
    editname: 'Change the name of the measuring point',
    delesheb: 'Please delete the bound device first!',
    desheb1: 'Please delete the scheduled task first!',
    deceb2: 'Please delete scheduled tasks and bound devices first!',
    movertk: "GNSS/RTK displacement monitoring network configuration",
    minilist: 'Monitoring point list',
    minidata: 'Monitoring data page',
    shebeilist: 'Device List',
    northmost: 'Single Beidou mode',
    addmini: 'Add benchmark or monitoring stations',
    shebeiID: 'Device ID',
    cebian: 'Measuring point number',
    currentstatus: 'Current status',
    yiinfo: 'Exception message',
    restele: 'Power level（%）',
    opentime: 'Shutdown time',
    laststarttime: "Next startup time",
    caozuo: 'Operation',
    zhongduaninfo: 'Terminal information',
    jiemodel: 'Power Saving Mode',
    setiing: "Setting",
    changeset: 'Replace the device',
    weixing: 'Satellite elevation angle',
    weixingyangjiao: "Satellite elevation range：",
    dingtask: 'Scheduled task',
    starttime: 'Start time',
    intersetime: 'Interval time',
    edit: 'Edit',
    waring: 'Alarm threshold',
    waringred: 'Measurement points exceeding alarm values 1 and 2 in the satellite map measurement point list are marked in yellow and red, respectively',
    waringone: 'Alarm threshold one',
    waringsecond: 'Alarm threshold two',
    sava: 'Save',
    movebind: 'GNSS/RTK displacement monitoring device binding',
    decideset: 'Device Status',
    wuonlie: 'IoT expiration date',
    leave: 'Offline time',
    comfirmbind: 'Bound',
    online: 'online',
    type: 'Type',
    movezhongduan: 'GNSS/RTK displacement terminal information',
    eleshuru: "Power input (V)",
    insetshu: "Built in battery (V)",
    inseteld: "Remaining power of built-in battery (%)",
    template: "Temperature (°C)",
    singqiang: 'Signal strength',
    upgengtime: 'Information update time',
    fourdata: "4G expiration date",
    setingrtk: 'GNSS/RTK parameter settings:',
    movejianceshe: 'GNSS/RTK displacement monitoring replacement equipment ID',
    rtkweiyiset: "GNSS/RTK displacement monitoring settings",
    decidetype: 'Device Type',
    shedeid: 'GNSS/RTK device ID',
    bind: "Unbind",
    unbind: "Binding",
    openjie: 'Activate energy-saving mode, RTK intermittently online, confirm execution？',
    openjie1: 'Turn off energy-saving mode, RTK is always online, confirm execution?',
    Confirmbind: 'Are you sure to unbind?',
    Confirmunbind: 'Are you sure to bind?',
    rebind: "It has already been bound to other projects. If you rebind this project, it will result in the inability to collect data from other projects. Are you sure?",
    reunbinf: "It has already been bound to other monitoring networks of this project. If re bound, it will result in the inability to collect data from other monitoring networks of this project. Are you sure?",
    gujiangzhixing: 'Are you sure to perform firmware upgrade?',
    comfirntask: "Are you sure to delete scheduled tasks",
    qingshucedian:'Please enter the name of the measuring point',
    cexiu:'The measurement point name has been successfully modified!',
    rejicemc:'Please enter the name of the monitoring network',
    lengduxian:'The length is 20 characters',
     gnde:'Please enter the GNSS/RTK device ID',
    pleaswei:'Please enter the satellite elevation angle',
    plesedecide:'Please select device type',
    pleasede:'Please enter the device ID',
    pbianma:'Please enter the measurement point number',
    pleyang:'Please enter the elevation satellite value',
    mibu:'The password entered twice is inconsistent!',
    setdaneb:'Single Beidou mode successfully set',
    celdanbei:'Cancel single Beidou mode setting successfully',
    peweinum:'Please enter the satellite elevation angle value',
    re1:'The value must be between -90 and 90',
    weicheng:'Satellite elevation angle successfully set',
    rechange:'The device has been replaced',
    yib:'Bound',
    waring1:'Alarm value 1, please enter a positive value and only retain one decimal place',
    bao2:'Alarm value 2 is greater than alarm value 1',
    baocheng:'Save successful',
    caisu:'Collection task added successfully',
    caixiu:'Collection task modified successfully',
    sunse:'Device already exists',
    yij:'Unbound'

  },
  // 设置
  // 设置
  head: {
    set: 'Setting',
    userpineng: "Default use of approval function",
    usershenpineng: "Default use of audit function"

  },

  common: {
    tishi: 'hint',
    quxiao: 'cancel',
    Confirm: 'Confirm',
    bianji: 'edit',
    delete: 'Delete',
    add: 'newly added',
    copy: 'Copy',
    confirmdelete: 'Delete canceled',
    bianjiansuccess: "Modified successfully",
    bianjifail: 'Modification failed',
    deletesuccess: 'Deleted successfully',
    deletedata: 'Confirm to delete this task?',
    useddeteled: 'Deleted',
    fousu: 'Do you want to continue deleting?',
    caoqu: 'Operation canceled',
    addsuccess: 'Added successfully!',
    wulocation: "There is currently no location data available",
    upsuccess: 'Upload successful',
    upfail: 'Upload failed',
    plesefail: 'Request failed',
    upsize: 'The size of the uploaded file cannot exceed 10MB!',
    setdo: "Setup completed",
    tiantime: 'Please fill in the time',
    editmin: 'The modification operation is in progress and will take a few minutes to take effect',
    revalue: 'Recharge',
    dtudecideID: "DTU device status",
    calcelcao: 'Operation canceled',
    yisava: 'Saved',
    savexiao: 'Save failed',
    shofouzhixing: 'Are you sure to execute?',
    zhixingsucess: 'Execution successful'


  }
}


// WEBPACK FOOTER //
// ./src/i18n/locales/en-US.js